import React from "react";
import Link from "../components/Link";
import {
  collectupiflow,
  upiautopay,
  upioneTimemandate,
  upipaymentlinksapi,
  virtualupiidforb2bpayments,
} from "../../static/webP/upi-payment-gateway";
import {
  alignStart,
  contentBodyMarginClass,
  contentClassName,
  headingClass2,
  imageClassName,
  mobileVisibleHeading,
} from "../common/Styling";
import CheckList from "../components/CheckList/CheckList";
import TabPanel from "../components/Tabs/TabPanel";
import {
  CASHFREE_DOCS_BASE_URL,
  CASHFREE_URL,
  UPI_PAYMENT_GATEWAY_ASSETS_URL,
} from "../constants/Url";
import { MERCHANT_DASHBOARD_SIGNUP_URL } from "../constants/env";
import {
  qrCodeCheckList,
  upiPaymentLinkCheckList,
  virtualUpiIdCheckList,
} from "../constants/upi-payment-gateway";
import {
  upiOptions1,
  upiOptions2,
  upiOptions3,
  upiOptions4,
} from "../../static/webM";

export const checkoutOptionsData = [
  {
    key: 0,
    heading: "UPI Intent flow",

    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          isVideo
          img={{
            src: upiOptions1,
            mp4Src:
              "https://cashfreelogo.cashfree.com/website/landings/upi-payment/upioptions-1.mp4",
            placeholder: collectupiflow,
            width: "1220",
            height: "934",
          }}
          heading="UPI Intent flow"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                Simplify{" "}
                <h2 className="inline font-body font-normal text-base">
                  UPI payments
                </h2>{" "}
                for your customer by automatically opening UPI apps installed in
                customer’s mobile for faster checkout.
              </div>
            </>
          }
          footer={
            <a
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              href={`${MERCHANT_DASHBOARD_SIGNUP_URL}?source-action=UPI%20PG&action=Sign%20Up&button-id=StartNow_UPIIntentFlow`}>
              Create Account <span className="chevron" />
            </a>
          }
        />
      </div>
    ),
  },
  {
    key: 1,
    heading: "UPI Dynamic QR code",

    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          isVideo
          img={{
            src: upiOptions2,
            mp4Src:
              "https://cashfreelogo.cashfree.com/website/landings/upi-payment/upioptions-2.mp4",
            placeholder: virtualupiidforb2bpayments,
            width: "1220",
            height: "934",
          }}
          heading="UPI Dynamic QR code"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                <h2 className="inline font-body font-normal text-base">
                  Generate QR code
                </h2>{" "}
                on your website checkout page and let customers scan and pay
                using any UPI app.
              </div>
            </>
          }
          footer={
            <a
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              href={`${MERCHANT_DASHBOARD_SIGNUP_URL}?source-action=UPI%20PG&action=Sign%20Up&button-id=StartNow_UPIDynamicQRcode`}>
              Create Account <span className="chevron" />
            </a>
          }
        />
      </div>
    ),
  },
  {
    key: 2,
    heading: "Whatsapp UPI Links",

    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          isVideo
          img={{
            src: upiOptions3,
            mp4Src:
              "https://cashfreelogo.cashfree.com/website/landings/upi-payment/upioptions-3.mp4",
            placeholder: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/upioptions-3.png`,
            width: "1220",
            height: "934",
          }}
          heading="Whatsapp UPI Links"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                <h2 className="inline font-body font-normal text-base">
                  Generate UPI link
                </h2>{" "}
                and share with customers over WhatsApp and get paid instantly.
              </div>
            </>
          }
          footer={
            <a
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              href={`${MERCHANT_DASHBOARD_SIGNUP_URL}?source-action=UPI%20PG&action=Sign%20Up&button-id=StartNow_WhatsappUPILinks`}>
              Create Account <span className="chevron" />
            </a>
          }
        />
      </div>
    ),
  },
  {
    key: 3,
    heading: "Collect UPI flow",

    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          isVideo
          img={{
            src: upiOptions4,
            mp4Src:
              "https://cashfreelogo.cashfree.com/website/landings/upi-payment/upioptions-4.mp4",
            placeholder: collectupiflow,
            width: "1220",
            height: "934",
          }}
          heading="Collect UPI flow"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                Send a payment collect request to the customer’s phone number or
                UPI ID and accept payments via UPI.
              </div>
            </>
          }
          footer={
            <a
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              href={`${MERCHANT_DASHBOARD_SIGNUP_URL}?source-action=UPI%20PG&action=Sign%20Up&button-id=StartNow_CollectUPIFlow`}>
              Create Account <span className="chevron" />
            </a>
          }
        />
      </div>
    ),
  },
];

export const faqData = [
  {
    id: 0,
    q: "What is a UPI Payment Gateway?",
    a: (
      <>
        <p>
          A UPI (Unified Payments Interface) payment gateway is a digital
          service that facilitates online transactions via the UPI
          infrastructure. It&apos;s essentially a bridge between a
          customer&apos;s bank account and a merchant&apos;s bank account,
          allowing for instant money transfers through a secure, real-time
          system.
        </p>
      </>
    ),
  },
  {
    id: 1,
    q: "How does a UPI Payment Gateway work?",
    a: (
      <>
        <p>The following stages are involved in a UPI transaction -</p>
        <p>
          <b>Initiation:</b> A customer initiates a transaction on a website or
          app, selecting UPI as their preferred payment method.
        </p>
        <p>
          <b>UPI Interface:</b> The UPI payment gateway presents the customer
          with an interface to enter their UPI ID (also known as a Virtual
          Payment Address or VPA). Alternatively, the customer may be presented
          with a QR code to scan using their UPI-enabled mobile app.
        </p>
        <p>
          <b> Authorization:</b> The customer authorizes the transaction on
          their UPI app, typically by entering a secure PIN.
        </p>
        <p>
          <b>Completion:</b> Once authorized, the transaction is processed in
          real time. The funds are transferred directly from the customer&apos;s
          bank account to the merchant&apos;s bank account.
        </p>
        <p>
          <b>Confirmation:</b> The merchant and the customer receive
          confirmation of the transaction.
        </p>
        <p>
          A UPI payment gateway is useful for businesses because it allows them
          to accept payments directly from a customer&apos;s bank account,
          simplifying the payment process and reducing the reliance on physical
          card infrastructure. It also enables customers to make payments
          anytime, anywhere, using just their mobile device.
        </p>
      </>
    ),
  },
  {
    id: 2,
    q: "What is the maximum transaction limit for a customer?",
    a: (
      <>
        <p>
          The UPI transaction limit can vary from bank to bank, but generally,
          the UPI transaction limit per day is set at ₹ 1 lakh, as defined by
          the National Payments Corporation of India (NPCI). The limit can be
          categorized into two aspects:
        </p>
        <p>
          {" "}
          <b>Limit of the transaction amount:</b> the maximum amount of money
          that can be transferred via UPI.
        </p>
        <p>
          <b>Frequency:</b> the number of UPI transactions a person can do in a
          day.
        </p>
        <p>
          For instance, State Bank of India (SBI) has a UPI limit per day of ₹
          1,00,000. Some banks also set a limit for how much can be transferred
          through UPI in a week. For example, IDFC bank has a UPI limit per week
          of ₹ 1,00,000. For more details, read{" "}
          <a
            href={`${CASHFREE_URL}/blog/upi-transaction-limit/`}
            className="email-link"
            target="_blank"
            rel="noreferrer">
            here.
          </a>
        </p>
      </>
    ),
  },
  {
    id: 3,
    q:
      "Do I need to pay any charge to collect UPI payments for my business using Cashfree?",
    a: (
      <p>
        For merchants using Cashfree&apos;s Payment Gateway,we charge{" "}
        <b className="underline">0% MDR per transaction</b> on collections using
        UPI payment mode. Read mode wise pricing{" "}
        <a href="/payment-gateway-charges/" className="email-link">
          here
        </a>{" "}
        in detail.
      </p>
    ),
  },
  {
    id: 4,
    q: "How can I collect payments using UPI payment gateway for my business?",
    a: (
      <p>
        As a merchant, you don’t have to integrate with different UPI apps
        separately. You can integrate Cashfree Payments UPI Payment Gateway with
        your website or mobile app to offer 20+ UPI apps to your customers in
        one place. For step-wise integration guide, watch{" "}
        <a
          href="https://www.youtube.com/watch?v=oSosi4waSR0"
          className="email-link">
          this video.
        </a>
      </p>
    ),
  },
  {
    id: 5,
    q: "When does the business owner get the money that was paid using UPI?",
    a: (
      <p>
        In UPI, the money is settled as per mutually agreed upon settlement
        terms. Default settlement cycle is (T+2)* days where (T) is the day of
        transaction. Many businesses with Cashfree opt for{" "}
        <a
          href={`${CASHFREE_URL}/blog/instant-settlements/`}
          className="email-link">
          instant settlements
        </a>{" "}
        to manage their working capital effectively.
      </p>
    ),
  },
  {
    id: 6,
    q:
      "What are the different UPI payment apps supported by Cashfree Payment Gateway?",
    a: (
      <p>
        The UPI Payment Gateway provided by Cashfree is compatible with all PSPs
        such as PhonePe, Google Pay, Paytm, CRED, among others. For a
        comprehensive list, please visit{" "}
        <a
          href="https://www.npci.org.in/what-we-do/upi/3rd-party-apps"
          target="_blank"
          className="email-link"
          rel="noreferrer">
          https://www.npci.org.in/what-we-do/upi/3rd-party-apps
        </a>
      </p>
    ),
  },
  {
    id: 7,
    q: "How can I collect payments via UPI QR code?",
    a: (
      <>
        <p>
          To support the requirements of omni-channel merchants which has both
          offline and online presence, Cashfree Payments offers Static QR under
          Payment Gateway where merchant can generate one (or) multiple Static
          QR codes, where they can accept payment of any amount. A dynamic QR
          code, on the other hand, has a fixed amount linked to it. Customers
          can pay only the fixed amount assigned to the QR code. For each
          transaction, a unique dynamic QR code is generated with a pre-defined
          payment amount.
        </p>
        <p>
          Based on your customer use case, you can choose between static and
          dynamic QR codes to accept payments. Read more about UPI QR code{" "}
          <a href="/upi-qr-code/" className="email-link">
            here.
          </a>
        </p>
      </>
    ),
  },

  {
    id: 8,
    q: "How does Cashfreee ensure higher success rates on UPI transactions?",
    a: (
      <p>
        Cashfree&apos;s UPI Payment Gateway has deep integration with 8+banks
        and uses state-of-the-art real time dynamic routing between multiple
        banks to maximise the success rate for its customers.
      </p>
    ),
  },
  {
    id: 9,
    q:
      "Is there a separate integration required to accept UPI payments on Cashfree Payment Gateway?",
    a: (
      <p>
        Absolutely not! If you are a merchant using Cashfree Payment Gateway, no
        additional activation is required to start using UPI for accepting
        payments. To get access to merchant dashboard of Payment Gateway,{" "}
        <a
          href="/contact-sales/?source-action=Home%20page&action=Contact%20Sales&button-id=ContactSales_Hero"
          className="email-link">
          connect
        </a>{" "}
        with us.
      </p>
    ),
  },
  {
    id: 10,
    q: "How safe are UPI payments?",
    a: (
      <>
        <p>
          Unified Payments Interface (UPI) transactions are generally considered
          safe due to several security features and protocols established by
          NPCI -
        </p>
        <p>
          <b>Two-Factor Authentication:</b> UPI transactions require two-factor
          authentication, which typically involves a combination of something
          the user knows (like a password) and something the user has (like a
          mobile phone). This significantly reduces the risk of unauthorized
          transactions.
        </p>
        <p>
          <b>Encryption: </b>UPI transactions are encrypted, which means that
          the data sent over the network is scrambled and can only be read by
          the intended recipient.
        </p>
        <p>
          <b>Regulation:</b> UPI is regulated by the Reserve Bank of India and
          developed by the National Payments Corporation of India (NPCI),
          ensuring a high standard of security and regulatory oversight.
        </p>
        <p>
          <b>Transaction Limits:</b> UPI has daily transaction limits which
          provide an additional layer of protection against fraud.
        </p>
        <p>
          <b>Immediate Alerts:</b> Users receive instant notifications for all
          transactions, allowing them to quickly detect and report any
          suspicious activity.
        </p>
        <p>
          However, users can mitigate risks by being vigilant, never sharing
          their UPI PIN with anyone, keeping their mobile operating system and
          UPI apps up-to-date, and only conducting transactions with trusted
          parties.
        </p>
      </>
    ),
  },
  {
    id: 11,
    q:
      "What are the different UPI checkout flows I can explore for my website/app?",
    a: (
      <>
        <p>
          Cashfree UPI Payment Gateway is built to serve all business needs
          effectively. The 4 workflows supported for UPI checkout experience
          include -
        </p>
        <ul className="list-disc">
          <li>UPI Intent flow</li>
          <li>UPI Dynamic QR code</li>
          <li>Whatsapp UPI Links</li>
          <li>Collect UPI flow</li>
        </ul>
      </>
    ),
  },
];

export const glossaryCards = [
  {
    id: 0,
    src: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/glossary-1.svg`,
    title: "UPI",
    text: (
      <>
        Unified Payments Interface (UPI) is real-time, secure payment system
        developed by National Payments Corporation of India (NPCI). It helps in
        immediate money transfer easily through mobile device 24*7 and
        365&nbsp;days.
      </>
    ),
  },
  {
    id: 1,
    src: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/glossary-2.svg`,
    title: "UPI ID",
    text: (
      <>
        UPI ID is a unique identifier to each UPI linked bank account and are
        used to facilitate payments between customers and merchants. It provides
        a Virtual Payments Address (UPI VPA) to enter when transferring money to
        the account linked to a UPI&nbsp;ID.
      </>
    ),
  },
  {
    id: 2,
    src: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/glossary-3.svg`,
    title: "UPI PIN",
    text: (
      <>
        UPI PIN is a unique 4 or 6 digit pin that the user has to set to
        authenticate every payment made via UPI&nbsp;apps.
      </>
    ),
  },
];

export const gatewatSuiteData = [
  {
    key: 0,
    heading: (
      <h2 className="inline font-body text-[16px]">UPI Payment Links API</h2>
    ),
    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          img={{
            src: upipaymentlinksapi,
            width: "610",
            height: "460",
          }}
          heading="UPI Payment Links API"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                <CheckList
                  className="mb-0"
                  fontClass="font-normal"
                  customText=""
                  data={upiPaymentLinkCheckList}
                  itemMargin="mb-4 md:mb-3"
                />
              </div>
            </>
          }
          footer={
            <a
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              href={`${CASHFREE_DOCS_BASE_URL}/reference/createpaymentlink`}
              target="_blank"
              rel="noreferrer">
              Check documentation <span className="chevron" />
            </a>
          }
        />
      </div>
    ),
  },
  {
    key: 1,
    heading: "Dynamic QR code",
    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          img={{
            src: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/upi-gateway-2.png`,
            width: "610",
            height: "460",
          }}
          heading="Dynamic QR code"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                <CheckList
                  className="mb-0"
                  fontClass="font-normal"
                  customText=""
                  data={qrCodeCheckList}
                  itemMargin="mb-4 md:mb-3"
                />
              </div>
            </>
          }
          footer={
            <a
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              target="_blank"
              rel="noreferrer"
              href={`${CASHFREE_DOCS_BASE_URL}/reference/create-dynamic-qr-code`}>
              Check documentation <span className="chevron" />
            </a>
          }
        />
      </div>
    ),
  },
  {
    key: 2,
    heading: "Static QR code",
    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          img={{
            src: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/upi-gateway-3.png`,
            width: "610",
            height: "460",
          }}
          heading="Static QR code"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                Manage your offline payments collection easily by generating QR
                code from your desktop or your softPOS app.
              </div>
            </>
          }
          footer={
            <Link
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              to="/soft-pos/">
              Learn more <span className="chevron" />
            </Link>
          }
        />
      </div>
    ),
  },
  {
    key: 3,
    heading: (
      <span>
        <h2 className="inline font-body text-[16px]">Virtual UPI ID</h2> for B2B
        Payments
      </span>
    ),
    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          img={{
            src: virtualupiidforb2bpayments,
            width: "610",
            height: "460",
          }}
          headingType="div"
          heading={
            <>
              <h2 className="inline font-body  text-3md md:text-shs font-semibold">
                Virtual UPI ID
              </h2>{" "}
              for B2B Payments
            </>
          }
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                <CheckList
                  className="mb-0"
                  fontClass="font-normal"
                  customText=""
                  data={virtualUpiIdCheckList}
                  itemMargin="mb-4 md:mb-3"
                />
              </div>
            </>
          }
          footer={
            <Link
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              to="/virtual-payment-address/">
              Learn more <span className="chevron" />
            </Link>
          }
        />
      </div>
    ),
  },
  {
    key: 4,
    heading: "UPI AutoPay",
    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          img={{
            src: upiautopay,
            width: "610",
            height: "460",
          }}
          heading="UPI AutoPay"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                Automate recurring payments collection upto ₹15,000 with one
                time UPI mandate authorization and grow your subscription
                business.
              </div>
            </>
          }
          footer={
            <Link
              className="button button-green mt-8 md:mt-0 mr-4 wide w-full md:w-auto"
              style={{ lineHeight: "1" }}
              to="/upi-autopay/">
              Learn more <span className="chevron" />
            </Link>
          }
        />
      </div>
    ),
  },
  {
    key: 5,
    heading: "UPI one-time mandate",
    content: (
      <div className="md:mt-[60px]">
        <TabPanel
          alignStart={alignStart}
          headingClass={headingClass2}
          img={{
            src: upioneTimemandate,
            width: "610",
            height: "460",
          }}
          heading="UPI one-time mandate"
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          imageClassName={imageClassName}
          contentClassName={contentClassName}
          body={
            <>
              <div className={contentBodyMarginClass}>
                Hold customer payments via one-time mandate{" "}
                <span className="whitespace-nowrap">pre-authorization</span>
                from any UPI app. Without manual intervention, you can
                auto-debit from your customer’s accounts on the
                authorized&nbsp;date.
              </div>
            </>
          }
          footer={null}
        />
      </div>
    ),
  },
];
